import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SuperadminAuthProvider } from './context/SuperadminAuthContext';
import RequireCompanyAuth from './components/RequireCompanyAuth';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CentralPage from './pages/central/CentralPage';
import SalesMonitoringPage from './pages/central/SalesMonitoringPage';
import ExpressMonitoringPage from './pages/central/ExpressMonitoringPage';
import CloseSalesPage from './pages/central/CloseSalesPage';
import SeeParametersPage from './pages/central/SeeParametersPage';
import NullifyTicketPage from './pages/central/NullifyTicketPage';
import ChangeTerminalPasswordPage from './pages/central/ChangeTerminalPasswordPage';
import VerifierTicketPage from './pages/central/VerifierTicketPage';
import RevertNullifiedTicketPage from './pages/central/RevertNullifiedTicketPage';
import PayTicketPage from './pages/central/PayTicketPage';
import WinningNumbersPage from './pages/central/WinningNumbersPage';
import BanquesConnectePage from './pages/central/BanquesConnectePage';
import ReportsPage from './pages/reports/ReportsPage';
import ReportWinningNumbersPage from './pages/reports/ReportWinningNumbersPage';
import WinningTicketsPage from './pages/reports/WinningTicketsPage';
import PrizedNumbersPage from './pages/reports/PrizedNumbersPage';
import TerminalReportPage from './pages/reports/TerminalReportPage';
import BankReportPage from './pages/reports/BankReportPage';
import AccumulatedSummaryPage from './pages/reports/AccumulatedSummaryPage';
import CumulDetaillePage from './pages/reports/CumulDetaillePage';
import TicketsVendusPage from './pages/reports/TicketsVendusPage';
import TicketsAnnulesPage from './pages/reports/TicketsAnnulesPage';
import ResumeBanqueLotteryPage from './pages/reports/ResumeBanqueLotteryPage';
import GeneralReportPage from './pages/reports/GeneralReportPage';
import ListeVentesPage from './pages/reports/ListeVentesPage';
import ControlesPage from './pages/controle/ControlesPage';
import EliminarParametrosPage from './pages/controle/EliminarParametrosPage';
import ParametresLoteriePage from './pages/controle/ParametresLoteriePage';
import MarriageGratisPage from './pages/controle/MarriageGratisPage';
import NumberControlPage from './pages/controle/NumberControlPage';
import ExpositionPage from './pages/controle/ExpositionPage';
import SecuritePage from './pages/securite/SecuritePage';
import KonbinezonRatioPage from './pages/securite/KonbinezonRatioPage';
import KonbinezonValidationPage from './pages/securite/KonbinezonValidationPage';
import BorletteCoveragePage from './pages/securite/BorletteCoveragePage';
import MaryajRatioPage from './pages/securite/MaryajRatioPage';
import MaxBoulesPage from './pages/securite/MaxBoulesPage';
import AuditLogPage from './pages/securite/AuditLogPage';
import BanquePage from './pages/parametres/BanquePage';
import BanqueDetailPage from './pages/parametres/BanqueDetailPage';
import BankRechargePage from './pages/parametres/BankRechargePage';
import CompanyProfilePage from './pages/parametres/CompanyProfilePage';
import FacturationPage from './pages/parametres/FacturationPage';
import ParametresPage from './pages/parametres/ParametresPage';
import SupervisorPermissionsPage from './pages/parametres/SupervisorPermissionsPage';
import SupervisorsPage from './pages/parametres/SupervisorsPage';
import ActiverBanqueManuelPage from './pages/parametres/ActiverBanqueManuelPage';
import MessagePage from './pages/parametres/MessagePage';
import CompanyUsersPage from './pages/parametres/CompanyUsersPage';
import TiragesPage from './pages/parametres/TiragesPage';
import PaymentInvoicePage from './pages/PaymentInvoicePage';
import SuperadminLoginPage from './pages/superadmin/SuperadminLoginPage';
import SuperadminCompaniesPage from './pages/superadmin/SuperadminCompaniesPage';
import SuperadminTiragesPage from './pages/superadmin/SuperadminTiragesPage';
import SuperadminCompanyFormPage from './pages/superadmin/SuperadminCompanyFormPage';
import SuperadminDevicesPage from './pages/superadmin/SuperadminDevicesPage';
import SuperadminBanksPage from './pages/superadmin/SuperadminBanksPage';
import SuperadminKioskRequestsPage from './pages/superadmin/SuperadminKioskRequestsPage';
import SuperadminDashboardPage from './pages/superadmin/SuperadminDashboardPage';
import SuperadminWinningNumbersPage from './pages/superadmin/SuperadminWinningNumbersPage';
import SuperadminAvisPage from './pages/superadmin/SuperadminAvisPage';
import SuperadminTransfersPage from './pages/superadmin/SuperadminTransfersPage';
import SuperadminTicketSearchPage from './pages/superadmin/SuperadminTicketSearchPage';
import SuperadminAuditLogPage from './pages/superadmin/SuperadminAuditLogPage';
import SuperadminBillingPage from './pages/superadmin/SuperadminBillingPage';
import SuperadminPaymentSubmissionsPage from './pages/superadmin/SuperadminPaymentSubmissionsPage';
import SuperadminReportsPage from './pages/superadmin/SuperadminReportsPage';
import SuperadminStaffUsersPage from './pages/superadmin/SuperadminStaffUsersPage';
import RequireSuperadminAuth from './components/RequireSuperadminAuth';
import { SupervisorAuthProvider } from './context/SupervisorAuthContext';
import { SubSupervisorAuthProvider } from './context/SubSupervisorAuthContext';
import RequireSupervisorAuth from './components/RequireSupervisorAuth';
import RequireSubSupervisorAuth from './components/RequireSubSupervisorAuth';
import SupervisorBanksPage from './pages/supervisor/SupervisorBanksPage';
import SupervisorProductConfigPage from './pages/supervisor/SupervisorProductConfigPage';
import SupervisorNumberLimitPage from './pages/supervisor/SupervisorNumberLimitPage';
import SupervisorCumulDetaillePage from './pages/supervisor/SupervisorCumulDetaillePage';
import SupervisorPrizedNumbersPage from './pages/supervisor/SupervisorPrizedNumbersPage';
import SupervisorAccumulatedSummaryPage from './pages/supervisor/SupervisorAccumulatedSummaryPage';
import SupervisorTicketsVendusPage from './pages/supervisor/SupervisorTicketsVendusPage';
import SupervisorDashboardPage from './pages/supervisor/SupervisorDashboardPage';
import SupervisorReportsPage from './pages/supervisor/SupervisorReportsPage';
import SupervisorWinningNumbersPage from './pages/supervisor/SupervisorWinningNumbersPage';
import SupervisorSubSupervisorsPage from './pages/supervisor/SupervisorSubSupervisorsPage';
import SupervisorCentralPage from './pages/supervisor/SupervisorCentralPage';
import SupervisorParametresPage from './pages/supervisor/SupervisorParametresPage';
import SupervisorControlesPage from './pages/supervisor/SupervisorControlesPage';
import SupervisorSalesMonitoringPage from './pages/supervisor/SupervisorSalesMonitoringPage';
import SupervisorBanquesConnectePage from './pages/supervisor/SupervisorBanquesConnectePage';
import SupervisorGeneralReportPage from './pages/supervisor/SupervisorGeneralReportPage';
import SupervisorSalesListPage from './pages/supervisor/SupervisorSalesListPage';
import SupervisorWinningTicketsPage from './pages/supervisor/SupervisorWinningTicketsPage';
import SupervisorTicketsAnnulesPage from './pages/supervisor/SupervisorTicketsAnnulesPage';
import SupervisorResumeBanqueLotteryPage from './pages/supervisor/SupervisorResumeBanqueLotteryPage';
import SupervisorTerminalReportPage from './pages/supervisor/SupervisorTerminalReportPage';
import SupervisorBankReportPage from './pages/supervisor/SupervisorBankReportPage';
import SupervisorBanquePage from './pages/supervisor/SupervisorBanquePage';
import SupervisorBanqueDetailPage from './pages/supervisor/SupervisorBanqueDetailPage';
import SupervisorActiverBanqueManuelPage from './pages/supervisor/SupervisorActiverBanqueManuelPage';
import SupervisorCloseSalesPage from './pages/supervisor/SupervisorCloseSalesPage';
import SupervisorSeeParametersPage from './pages/supervisor/SupervisorSeeParametersPage';
import SupervisorVerifierTicketPage from './pages/supervisor/SupervisorVerifierTicketPage';
import {
  SupervisorChangeTerminalPasswordPage,
  SupervisorExpressMonitoringPage,
  SupervisorNullifyTicketPage,
  SupervisorPayTicketPage,
  SupervisorRevertNullifiedTicketPage,
} from './pages/supervisor/SupervisorCentralExtraPages';
import SubSupervisorLoginPage from './pages/subsupervisor/SubSupervisorLoginPage';
import SubSupervisorBanksPage from './pages/subsupervisor/SubSupervisorBanksPage';

// Chaque provider ne doit envelopper que son propre sous-arbre de routes : sinon
// AuthProvider (company) et SuperadminAuthProvider tournent tous les deux sur CHAQUE
// page (cote company ET cote superadmin), et chacun ping son endpoint /me/ qui repond
// 403 sur le mauvais cote — bruit inoffensif mais visible dans le reseau/console.
const CompanyProviderLayout = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

const SuperadminProviderLayout = () => (
  <SuperadminAuthProvider>
    <Outlet />
  </SuperadminAuthProvider>
);

const SupervisorProviderLayout = () => (
  <SupervisorAuthProvider>
    <Outlet />
  </SupervisorAuthProvider>
);

const SubSupervisorProviderLayout = () => (
  <SubSupervisorAuthProvider>
    <Outlet />
  </SubSupervisorAuthProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<CompanyProviderLayout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />

          <Route element={<RequireCompanyAuth />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/central" element={<CentralPage />} />
            <Route path="/sales-monitoring" element={<SalesMonitoringPage />} />
            <Route path="/express-monitoring" element={<ExpressMonitoringPage />} />
            <Route path="/close-sales" element={<CloseSalesPage />} />
            <Route path="/see-parameters" element={<SeeParametersPage />} />
            <Route path="/nullify-ticket" element={<NullifyTicketPage />} />
            <Route path="/change-terminal-password" element={<ChangeTerminalPasswordPage />} />
            <Route path="/verify-ticket" element={<VerifierTicketPage />} />
            <Route path="/revert-nullified-ticket" element={<RevertNullifiedTicketPage />} />
            <Route path="/pay-ticket" element={<PayTicketPage />} />
            <Route path="/winning-numbers" element={<WinningNumbersPage />} />
            <Route path="/banques-connecte" element={<BanquesConnectePage />} />
            <Route path="/paiement/:invoiceId" element={<PaymentInvoicePage />} />
            <Route path="/rapports" element={<ReportsPage />} />
            <Route path="/rapports/general" element={<GeneralReportPage />} />
            <Route path="/rapports/liste-ventes" element={<ListeVentesPage />} />
            <Route path="/rapports/winning-numbers" element={<ReportWinningNumbersPage />} />
            <Route path="/rapports/winning-tickets" element={<WinningTicketsPage />} />
            <Route path="/rapports/paris-gagnants" element={<PrizedNumbersPage />} />
            <Route path="/rapports/terminal-report" element={<TerminalReportPage />} />
            <Route path="/rapports/banques-rapport" element={<BankReportPage />} />
            <Route path="/rapports/accumulated-summary" element={<AccumulatedSummaryPage />} />
            <Route path="/rapports/cumul-detaille" element={<CumulDetaillePage />} />
            <Route path="/rapports/tickets-vendus" element={<TicketsVendusPage />} />
            <Route path="/rapports/tickets-annulaient" element={<TicketsAnnulesPage />} />
            <Route path="/rapports/resume-banque-lottery" element={<ResumeBanqueLotteryPage />} />
            <Route path="/controles" element={<ControlesPage />} />
            <Route path="/controles/parametres-loterie" element={<ParametresLoteriePage />} />
            <Route path="/controles/marriage-gratis" element={<MarriageGratisPage />} />
            <Route path="/controles/number-control" element={<NumberControlPage />} />
            <Route path="/controles/eliminar-parametros" element={<EliminarParametrosPage />} />
            <Route path="/controles/exposition" element={<ExpositionPage />} />
            <Route path="/securite" element={<SecuritePage />} />
            <Route path="/securite/konbinezon-ratio" element={<KonbinezonRatioPage />} />
            <Route path="/securite/konbinezon-validation" element={<KonbinezonValidationPage />} />
            <Route path="/securite/borlette-coverage" element={<BorletteCoveragePage />} />
            <Route path="/securite/maryaj-ratio" element={<MaryajRatioPage />} />
            <Route path="/securite/max-boules" element={<MaxBoulesPage />} />
            <Route path="/securite/audit-log" element={<AuditLogPage />} />
            <Route path="/parametres" element={<ParametresPage />} />
            <Route path="/parametres/superviseurs" element={<SupervisorsPage />} />
            <Route path="/parametres/act-desactiver-ventes-manuel" element={<ActiverBanqueManuelPage />} />
            <Route path="/parametres/message" element={<MessagePage />} />
            <Route path="/parametres/utilisateurs" element={<CompanyUsersPage />} />
            <Route path="/parametres/permissions-superviseur" element={<SupervisorPermissionsPage />} />
            <Route path="/parametres/compte" element={<CompanyProfilePage />} />
            <Route path="/parametres/facturation" element={<FacturationPage />} />
            <Route path="/parametres/banque" element={<BanquePage />} />
            <Route path="/parametres/banque/:id" element={<BanqueDetailPage />} />
            <Route path="/parametres/recharge" element={<BankRechargePage />} />
            <Route path="/parametres/tirages" element={<TiragesPage />} />
          </Route>
        </Route>

        <Route element={<SuperadminProviderLayout />}>
          <Route path="/superadmin/login" element={<SuperadminLoginPage />} />
          <Route element={<RequireSuperadminAuth />}>
            <Route path="/superadmin/dashboard" element={<SuperadminDashboardPage />} />
            <Route path="/superadmin/companies" element={<SuperadminCompaniesPage />} />
            <Route path="/superadmin/companies/new" element={<SuperadminCompanyFormPage />} />
            <Route path="/superadmin/companies/:id" element={<SuperadminCompanyFormPage />} />
            <Route path="/superadmin/tirages" element={<SuperadminTiragesPage />} />
            <Route path="/superadmin/devices" element={<SuperadminDevicesPage />} />
            <Route path="/superadmin/banks" element={<SuperadminBanksPage />} />
            <Route path="/superadmin/kiosk-requests" element={<SuperadminKioskRequestsPage />} />
            <Route path="/superadmin/winning-numbers" element={<SuperadminWinningNumbersPage />} />
            <Route path="/superadmin/avis" element={<SuperadminAvisPage />} />
            <Route path="/superadmin/transfers" element={<SuperadminTransfersPage />} />
            <Route path="/superadmin/ticket-search" element={<SuperadminTicketSearchPage />} />
            <Route path="/superadmin/audit-log" element={<SuperadminAuditLogPage />} />
            <Route path="/superadmin/facturation" element={<SuperadminBillingPage />} />
            <Route path="/superadmin/payment-submissions" element={<SuperadminPaymentSubmissionsPage />} />
            <Route path="/superadmin/reports" element={<SuperadminReportsPage />} />
            <Route path="/superadmin/staff-users" element={<SuperadminStaffUsersPage />} />
          </Route>
        </Route>

        <Route element={<SupervisorProviderLayout />}>
          {/* Plus de login separe : tout le monde passe par /login (2026-09-29). */}
          <Route path="/supervisor/login" element={<Navigate to="/login" replace />} />
          <Route element={<RequireSupervisorAuth />}>
            <Route path="/supervisor/banks" element={<SupervisorBanksPage />} />
            <Route path="/supervisor/sub-supervisors" element={<SupervisorSubSupervisorsPage />} />
            <Route path="/supervisor/product-configs" element={<SupervisorProductConfigPage />} />
            <Route path="/supervisor/number-limits" element={<SupervisorNumberLimitPage />} />
            <Route path="/supervisor/cumul-detaille" element={<SupervisorCumulDetaillePage />} />
            <Route path="/supervisor/prized-numbers" element={<SupervisorPrizedNumbersPage />} />
            <Route path="/supervisor/accumulated-summary" element={<SupervisorAccumulatedSummaryPage />} />
            <Route path="/supervisor/tickets-vendus" element={<SupervisorTicketsVendusPage />} />
            <Route path="/supervisor/dashboard" element={<SupervisorDashboardPage />} />
            <Route path="/supervisor/rapports" element={<SupervisorReportsPage />} />
            <Route path="/supervisor/winning-numbers" element={<SupervisorWinningNumbersPage />} />
            <Route path="/supervisor/central" element={<SupervisorCentralPage />} />
            <Route path="/supervisor/parametres" element={<SupervisorParametresPage />} />
            <Route path="/supervisor/controles" element={<SupervisorControlesPage />} />
            <Route path="/supervisor/sales-monitoring" element={<SupervisorSalesMonitoringPage />} />
            <Route path="/supervisor/banques-connecte" element={<SupervisorBanquesConnectePage />} />
            <Route path="/supervisor/verifier-ticket" element={<SupervisorVerifierTicketPage />} />
            <Route path="/supervisor/general-report" element={<SupervisorGeneralReportPage />} />
            <Route path="/supervisor/sales-list" element={<SupervisorSalesListPage />} />
            <Route path="/supervisor/winning-tickets" element={<SupervisorWinningTicketsPage />} />
            <Route path="/supervisor/tickets-annules" element={<SupervisorTicketsAnnulesPage />} />
            <Route path="/supervisor/resume-banque-lottery" element={<SupervisorResumeBanqueLotteryPage />} />
            <Route path="/supervisor/terminal-report" element={<SupervisorTerminalReportPage />} />
            <Route path="/supervisor/bank-report" element={<SupervisorBankReportPage />} />
            <Route path="/supervisor/banque" element={<SupervisorBanquePage />} />
            <Route path="/supervisor/banque/:id" element={<SupervisorBanqueDetailPage />} />
            <Route
              path="/supervisor/act-desactiver-ventes-manuel"
              element={<SupervisorActiverBanqueManuelPage />}
            />
            <Route path="/supervisor/close-sales" element={<SupervisorCloseSalesPage />} />
            <Route path="/supervisor/see-parameters" element={<SupervisorSeeParametersPage />} />
            <Route path="/supervisor/express-monitoring" element={<SupervisorExpressMonitoringPage />} />
            <Route path="/supervisor/change-terminal-password" element={<SupervisorChangeTerminalPasswordPage />} />
            <Route path="/supervisor/nullify-ticket" element={<SupervisorNullifyTicketPage />} />
            <Route path="/supervisor/revert-nullified-ticket" element={<SupervisorRevertNullifiedTicketPage />} />
            <Route path="/supervisor/pay-ticket" element={<SupervisorPayTicketPage />} />
          </Route>
        </Route>

        <Route element={<SubSupervisorProviderLayout />}>
          <Route path="/sub-supervisor/login" element={<SubSupervisorLoginPage />} />
          <Route element={<RequireSubSupervisorAuth />}>
            <Route path="/sub-supervisor/banks" element={<SubSupervisorBanksPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
